// Generated by CoffeeScript 2.4.1
(function() {
  var WeaverNodeList, _, addToMap,
    indexOf = [].indexOf;

  _ = require('lodash');

  addToMap = function(node, map) {
    if (map[node.id()] == null) {
      return map[node.id()] = node;
    } else {
      // resolve collision
      if (map[node.id()]._loaded && !node._loaded) {

      } else if (!map[node.id()]._loaded && node._loaded) {
        return map[node.id()] = node;
      } else {
        return console.log("Inside NodeList an unsolvable collision occurred, this is not something to worry about");
      }
    }
  };

  WeaverNodeList = class WeaverNodeList extends Array {
    static idsFromBindingSet(res) {
      var binding, ids, j, len, list, node;
      ids = [];
      for (binding in res) {
        list = res[binding];
        for (j = 0, len = list.length; j < len; j++) {
          node = list[j];
          if (node != null) {
            ids.push(node.id());
          }
        }
      }
      return ids;
    }

    static mapFromBindingSet(res, ...bindings) {
      var addRow, i, j, length, map, ref, ref1;
      map = {};
      addRow = function(map, res, i, bindings) {
        var binding, ref, rest, value;
        if ((bindings != null ? bindings.length : void 0) > 0) {
          [binding, ...rest] = bindings;
          value = (ref = res[binding][i]) != null ? ref.id() : void 0;
          if (value != null) {
            if (map[value] == null) {
              map[value] = {};
            }
            return addRow(map[value], res, i, rest);
          }
        }
      };
      length = ((ref = res[bindings[0]]) != null ? ref.length : void 0) || 0;
      for (i = j = 0, ref1 = length; (0 <= ref1 ? j < ref1 : j > ref1); i = 0 <= ref1 ? ++j : --j) {
        addRow(map, res, i, bindings);
      }
      return map;
    }

    constructor(arr = []) {
      var el, j, len;
      super();
// allows WeaverNodeList to be constructed like so: new WeaverNodeList(Array)
      for (j = 0, len = arr.length; j < len; j++) {
        el = arr[j];
        this.push(el);
      }
      this;
    }

    _getIdMap(nodes = this, map = {}) {
      var j, key, len, node, ref, rel;
      for (j = 0, len = nodes.length; j < len; j++) {
        node = nodes[j];
        addToMap(node, map);
        ref = node._relations;
        for (key in ref) {
          rel = ref[key];
          _getIdMap(rel.all(), map);
        }
      }
      return map;
    }

    _getIdMapByKey(key, nodes = this, map = {}) {
      var j, len, node;
      for (j = 0, len = nodes.length; j < len; j++) {
        node = nodes[j];
        addToMap(node, map);
        this._getIdMapByKey(key, node.relation(key).all(), map);
      }
      return map;
    }

    flattenByRelation(rel) {
      var id, node;
      return new WeaverNodeList((function() {
        var ref, results;
        ref = this._getIdMapByKey(rel);
        results = [];
        for (id in ref) {
          node = ref[id];
          results.push(node);
        }
        return results;
      }).call(this));
    }

    reduceOnlyLoaded() {
      return this.filter(function(n) {
        return n._loaded;
      });
    }

    // graphId -> nodeId -> node
    _updateIndex() {
      var graphId, j, len, node, ref;
      if (this._index == null) {
        this._index = {};
      }
      ref = this;
      for (j = 0, len = ref.length; j < len; j++) {
        node = ref[j];
        graphId = node.getGraph();
        if (this._index[graphId] == null) {
          this._index[graphId] = {};
        }
        this._index[graphId][node.id()] = node;
      }
      return this._index;
    }

    // this does not use recursion but visits all nodes' relations to's once
    unflatten() {
      var graphId, j, key, len, node, nodeId, nodes, record, ref, ref1, ref2, ref3, ref4, relNode, relNodeGraph, relNodeId, relation, toNode, toNodeGraph, toNodeId;
      this._updateIndex();
      ref = this._index;
      for (graphId in ref) {
        nodes = ref[graphId];
        for (nodeId in nodes) {
          node = nodes[nodeId];
          ref1 = node._relations;
          for (key in ref1) {
            relation = ref1[key];
            ref2 = relation._records;
            for (j = 0, len = ref2.length; j < len; j++) {
              record = ref2[j];
              // to node
              toNodeGraph = record.toNode.getGraph();
              toNodeId = record.toNode.id();
              toNode = (ref3 = this._index[toNodeGraph]) != null ? ref3[toNodeId] : void 0;
              if (record.toNode.equals(toNode)) {
                record.toNode = toNode;
              }
              // rel node
              relNodeGraph = record.relNode.getGraph();
              relNodeId = record.relNode.id();
              relNode = (ref4 = this._index[relNodeGraph]) != null ? ref4[relNodeId] : void 0;
              if (record.relNode.equals(relNode)) {
                record.relNode = relNode;
              }
            }
          }
        }
      }
      return this;
    }

    reduceNonReachable() {
      var graphId, j, key, len, node, nodeId, nodes, reachable, record, ref, ref1, ref2, ref3, ref4, relNodeGraph, relNodeId, relation, roots, toNodeGraph, toNodeId;
      this._updateIndex();
      reachable = {}; // graphId -> nodeId
      ref = this._index;
      for (graphId in ref) {
        nodes = ref[graphId];
        for (nodeId in nodes) {
          node = nodes[nodeId];
          ref1 = node._relations;
          for (key in ref1) {
            relation = ref1[key];
            ref2 = relation._records;
            for (j = 0, len = ref2.length; j < len; j++) {
              record = ref2[j];
              // to node
              toNodeGraph = record.toNode.getGraph();
              toNodeId = record.toNode.id();
              if (reachable[toNodeGraph] == null) {
                reachable[toNodeGraph] = [];
              }
              reachable[toNodeGraph].push(toNodeId);
              // rel node
              relNodeGraph = record.relNode.getGraph();
              relNodeId = record.relNode.id();
              if (reachable[relNodeGraph] == null) {
                reachable[relNodeGraph] = [];
              }
              reachable[relNodeGraph].push(relNodeId);
            }
          }
        }
      }
      roots = new WeaverNodeList();
      ref3 = this._index;
      for (graphId in ref3) {
        nodes = ref3[graphId];
        for (nodeId in nodes) {
          node = nodes[nodeId];
          if (ref4 = node.id(), indexOf.call(reachable[node.getGraph()], ref4) < 0) {
            roots.push(node);
          }
        }
      }
      return roots;
    }

    reduceNonReachableByKey(key) {
      var graphId, j, len, node, nodeId, nodes, reachable, ref, ref1, ref2, ref3, roots, toNode, toNodeGraph, toNodeId;
      this._updateIndex();
      reachable = {}; // graphId -> nodeId
      ref = this._index;
      for (graphId in ref) {
        nodes = ref[graphId];
        for (nodeId in nodes) {
          node = nodes[nodeId];
          ref1 = node.relation(key).all();
          for (j = 0, len = ref1.length; j < len; j++) {
            toNode = ref1[j];
            // to node
            toNodeGraph = toNode.getGraph();
            toNodeId = toNode.id();
            if (reachable[toNodeGraph] == null) {
              reachable[toNodeGraph] = [];
            }
            reachable[toNodeGraph].push(toNodeId);
          }
        }
      }
      roots = new WeaverNodeList();
      ref2 = this._index;
      for (graphId in ref2) {
        nodes = ref2[graphId];
        for (nodeId in nodes) {
          node = nodes[nodeId];
          if (ref3 = node.id(), indexOf.call(reachable[node.getGraph()], ref3) < 0) {
            roots.push(node);
          }
        }
      }
      return roots;
    }

    get(id, graph) {
      var ref;
      this._updateIndex();
      return (ref = this._index[graph]) != null ? ref[id] : void 0;
    }

  };

  // Export
  module.exports = WeaverNodeList;

}).call(this);
